import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'sq', name: 'Shqip', flag: '🇦🇱' },
  { code: 'mk', name: 'Македонски', flag: '🇲🇰' },
];

const LanguageSwitcher = ({ testId = 'language-switcher' }) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  return (
    <Select value={i18n.language} onValueChange={handleLanguageChange}>
      <SelectTrigger data-testid={testId} aria-label="Language" className="w-full h-8 bg-[#27272A] border-[#3F3F46] text-[#A1A1AA] text-xs hover:bg-[#2E2E32]">
        <div className="flex items-center gap-2">
          <Globe className="w-3.5 h-3.5 text-[#71717A]" />
          <SelectValue>
            <span className="flex items-center gap-2">
              <span>{currentLang.flag}</span>
              <span className="text-sm">{currentLang.name}</span>
            </span>
          </SelectValue>
        </div>
      </SelectTrigger>
      <SelectContent data-testid={`${testId}-menu`}>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code} data-testid={`${testId}-${lang.code}`}>
            <span className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
